import { useEffect, useState } from "react";
import api, { apiError } from "../../../lib/api";
import { toast } from "sonner";

export function AdminDocuments() {
  const [docs, setDocs] = useState([]);
  const [members, setMembers] = useState([]);
  const [f, setF] = useState({ user_id: "", title: "", category: "report" });
  const [file, setFile] = useState(null);
  const [bulk, setBulk] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/documents").then((r) => setDocs(r.data)).catch(() => {});
  useEffect(() => { load(); api.get("/admin/members").then((r) => setMembers(r.data)).catch(() => {}); }, []);

  const upload = async () => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("title", f.title);
      fd.append("category", f.category);
      if (bulk) {
        const { data } = await api.post("/admin/documents/bulk", fd, { headers: { "Content-Type": "multipart/form-data" } });
        toast.success(`Issued to ${data.issued} members. Each has been notified.`);
      } else {
        fd.append("user_id", f.user_id);
        await api.post("/admin/documents", fd, { headers: { "Content-Type": "multipart/form-data" } });
        toast.success("Document issued.");
      }
      setF({ user_id: "", title: "", category: "report" });
      setFile(null);
      load();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const rename = async (d) => {
    const title = window.prompt("New title", d.title);
    if (!title) return;
    try {
      await api.patch(`/admin/documents/${d.document_id}`, { title });
      toast.success("Renamed.");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  const retract = async (d) => {
    try {
      await api.delete(`/admin/documents/${d.document_id}`);
      toast.success("Retracted. The member can no longer see or download it.");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <div className="max-w-xl space-y-3" data-testid="admin-document-form">
        <span className="t-label">Issue a document to a member</span>
        <button className={`option-card ${bulk ? "selected" : ""}`} onClick={() => setBulk(!bulk)} data-testid="document-bulk-toggle">
          <span className="t-body">Issue to all members</span>
          <p className="t-small text-muted-s mt-1">One upload, issued to every member. Each member is notified. For quarterly reports and circulars.</p>
        </button>
        {!bulk && (
          <select className="input-solera" value={f.user_id} onChange={(e) => setF({ ...f, user_id: e.target.value })} data-testid="document-member-select">
            <option value="">Select member</option>
            {members.map((m) => <option key={m.user_id} value={m.user_id}>{`${m.name}, ${m.email}`}</option>)}
          </select>
        )}
        <input className="input-solera" placeholder="Title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="document-title-input" />
        <select className="input-solera" value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="document-category-select">
          {["subscription", "tax", "report", "memo", "other"].map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <input type="file" className="input-solera t-small" onChange={(e) => setFile(e.target.files[0])} data-testid="document-file-input" />
        <button className="btn-primary" disabled={busy || (!bulk && !f.user_id) || !f.title || !file} onClick={upload} data-testid="document-upload-button">
          {busy ? "Uploading" : bulk ? "Upload and issue to all" : "Upload and issue"}
        </button>
      </div>
      <table className="table-solera mt-12" data-testid="admin-documents-table">
        <thead><tr><th>Member</th><th>Title</th><th>Category</th><th>Date</th><th></th></tr></thead>
        <tbody>
          {docs.map((d) => (
            <tr key={d.document_id}>
              <td className="text-muted-s">{d.member_email}</td>
              <td className="text-bone">{d.title}</td>
              <td className="text-muted-s">{d.category}</td>
              <td className="text-muted-s t-small fig">{d.created_at?.slice(0, 10)}</td>
              <td className="text-right whitespace-nowrap space-x-4">
                <button onClick={() => rename(d)} className="t-label hover:!text-[#E8E6E1]" data-testid={`rename-doc-${d.document_id}`}>Rename</button>
                <button onClick={() => retract(d)} className="t-label hover:!text-[#E8E6E1]" data-testid={`retract-doc-${d.document_id}`}>Retract</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
